// apps/dashboard/src/stores/ws.store.ts
// WebSocket connection state managed by useWebSocket hook.

import { create } from 'zustand';

export type WsStatus = 'connecting' | 'connected' | 'disconnected' | 'error';

export interface QrEvent {
  phoneId: string;
  qrBase64: string;
  expiresAt: string;
  attempt: number;
}

export interface SessionStatusEvent {
  phoneId: string;
  status: 'CONNECTED' | 'DISCONNECTED';
  phoneNumber?: string;
  displayName?: string;
  reason?: string;
}

interface WsState {
  status: WsStatus;
  setStatus: (s: WsStatus) => void;
  // Keyed by phoneId — allows multiple QR codes for different sessions
  qrEvents: Record<string, QrEvent>;
  setQrEvent: (phoneId: string, evt: QrEvent) => void;
  clearQrEvent: (phoneId: string) => void;
  sessionStatuses: Record<string, 'CONNECTED' | 'DISCONNECTED'>;
  setSessionStatus: (phoneId: string, status: 'CONNECTED' | 'DISCONNECTED') => void;
}

export const useWsStore = create<WsState>()((set) => ({
  status: 'disconnected',
  setStatus: (status) => set({ status }),

  qrEvents: {},
  setQrEvent: (phoneId, evt) => set((s) => ({ qrEvents: { ...s.qrEvents, [phoneId]: evt } })),
  clearQrEvent: (phoneId) =>
    set((s) => {
      const { [phoneId]: _, ...rest } = s.qrEvents;
      return { qrEvents: rest };
    }),

  sessionStatuses: {},
  setSessionStatus: (phoneId, status) =>
    set((s) => ({ sessionStatuses: { ...s.sessionStatuses, [phoneId]: status } })),
}));
